module.exports = __webpack_public_path__ + "static/feetback-9d36ec085d97bf4a197bcb0b2c8913af.png";